import { motion } from "framer-motion";
import { team } from "../data/siteData";
import { Badge } from "../Components/ui/Badge";

export default function TeamSection() {
  return (
    <section id="team" className="border-t border-zinc-200 bg-white py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-16 text-center">
          <Badge className="mb-6 rounded-full border-0 bg-violet-50 px-4 py-1 text-brand-purple">
            Our People
          </Badge>
          <h2 className="mb-6 font-display text-4xl font-bold tracking-tight text-brand-ink md:text-5xl">
            Meet the team behind the <span className="text-brand-purple">spark.</span>
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-brand-muted">
            Engineers, designers, and strategists passionate about building software that matters.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {team.map((member, i) => (
            <motion.div
              key={member.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="group rounded-2xl border border-zinc-200 bg-white p-6 text-center transition-all hover:border-violet-200 hover:shadow-xl"
            >
              <div className="mx-auto mb-6 h-32 w-32 overflow-hidden rounded-full border-4 border-violet-50 transition-colors group-hover:border-violet-100">
                <img src={member.img} alt={member.name} className="h-full w-full object-cover transition-transform group-hover:scale-105" />
              </div>
              <h3 className="mb-1 font-display text-xl font-bold text-brand-ink">{member.name}</h3>
              <p className="mb-4 text-sm font-medium text-brand-purple">{member.role}</p>
              <p className="mx-auto max-w-xs text-sm text-brand-muted">
                {member.bio || "Passionate about scalable solutions and pixel-perfect user experiences."}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
